// removed by extract-text-webpack-plugin
module.exports = {"TarifSolo":"style__TarifSolo___3fJtO","TarifCompany":"style__TarifCompany___3e-Yc","TarifPay":"style__TarifPay___1AOmz","TarifPayHead":"style__TarifPayHead___ZSseD","VisaMAstercard":"style__VisaMAstercard___7Nu4B","Tarifs":"style__Tarifs___2o6vQ","TarifImage":"style__TarifImage___1ceRX","TarifName":"style__TarifName___3SfGX","TarifDescrip":"style__TarifDescrip___eg0MT","TarifPrice":"style__TarifPrice___2dDPE","TarifTerm":"style__TarifTerm___1iFCA","TarifBuyBtn":"style__TarifBuyBtn___1T5PM","TarifRequestBtn":"style__TarifRequestBtn___2HBuR","TarifText":"style__TarifText___3h59R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payments/PayForTarif/style.scss
// module id = 1367
// module chunks = 0